module.exports = __webpack_public_path__ + "img/309.fb107253.jpg";